import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { IQuestionnaireQuestion } from 'src/app/interfaces/Questionnaire/IQuestionnaire';
import { EpisodeOfCareService } from 'src/app/services/episodeOfCare.service';
import { PermissionService } from 'src/app/services/permission.service';

@Component({
  selector: 'app-eq5d-questions',
  templateUrl: './eq5d-questions.component.html',
  styleUrl: './eq5d-questions.component.css',
  standalone: false,
})
export class Eq5dQuestionsComponent implements OnInit {
  @Input() elements: IQuestionnaireQuestion[] = [];
  @Input() formGroup!: FormGroup;
  @Input() readonlyMode = false;

  constructor(
    private readonly eocService: EpisodeOfCareService,
    private readonly router: Router,
    private readonly permissionService: PermissionService,
  ) {}

  ngOnInit(): void {}

  isInpatientView(): boolean {
    return (
      !(
        this.eocService.currentEocId() === null ||
        this.eocService.currentEocId() === ''
      ) && this.router.url.includes('inPatientView')
    );
  }

  isEOC(): boolean {
    return (
      !(
        this.eocService.currentEocId() === null ||
        this.eocService.currentEocId() === ''
      ) && this.router.url.includes('episodeOfCare')
    );
  }

  hasPermission(permission: string[]): boolean {
    return this.permissionService.can(permission);
  }

  onRadioClick(controlName: string, value: any): void {
    if (this.readonlyMode) return;
    const control = this.formGroup.get(controlName);
    if (!control) return;

    if (control.value === value) {
      control.setValue(null);
    }
  }

  getQuestionTitle(title?: string): string {
    return title?.split('||')[0]?.trim() ?? '';
  }

  getQuestionInstruction(title?: string): string {
    return title?.split('||')[1]?.trim() ?? '';
  }
}